export interface LoginResponse {
	isError: boolean;
	code: number;
	message: string;
	data: {
		loginData: {
			language: string;
			userId: number;
			currencyCode: string;
			bonusBalance: number | null;
			login: string;
			email: string;
			balance: number;
			lastName: string;
			firstName: string;
			sessionStart: number;
			mobileNumber: string;
			status: string;
			sessionTime: number;
			mobile: number | null;
			bonusBalanceList: [];
			passwordHash: string | null;
			accountHash: string | null;
			uniqueHash: string | null;
			vip: boolean;
			calculatedBonus: number;
		};
		lastStake: number;
	};
}

export enum ErrorCodes {
	selfExclusion = 485,
	wrongPassword = 401,
	accountBlockedByCustomer = 486,
	dailyLoginTimeExceeded = 2011,
	monthlyLoginTimeExceeded = 2013,
	customerAccountNotActivated = 458,
	accountBlockedByAdmin = 475,
}

export const LoginErrors = new Map<number, string>([
	[ErrorCodes.selfExclusion, 'selfExclusionMessage'],
	[ErrorCodes.wrongPassword, 'wrongPasswordMessage'],
	[ErrorCodes.accountBlockedByCustomer, 'accountBlockedByCustomer'],
	[ErrorCodes.dailyLoginTimeExceeded, 'dailyLoginTimeExceeded'],
	[ErrorCodes.monthlyLoginTimeExceeded, 'monthlyLoginTimeExceeded'],
	[ErrorCodes.customerAccountNotActivated, 'customerAccountNotActivated'],
	[ErrorCodes.accountBlockedByAdmin, 'accountBlockedByAdmin'],
]);

export const vipUserDataLayer = (level: number) => {
	switch (level) {
		case 5:
			return ['vip-poziom-1'];
		case 4:
			return ['vip-poziom-2'];
		case 3:
			return ['vip-poziom-3'];
		case 2:
			return ['vip-poziom-4'];
		case 1:
			return ['vip-poziom-5'];
	}
};
